export const apiConstants = {
    API_START_CONTACTING: 'API_START_CONTACTING',
    API_END_CONTACTING: 'API_END_CONTACTING',
    API_CLEAR_MESSAGE: 'API_CLEAR_MESSAGE',
};